import { createActions } from "redux-actions";
const prefix = "BOOKTABLE";
const actionTypes = ["BEGIN", "EDIT", "RESET"];
const actionMap = {
  SEARCH: {
    SUBMIT: null
  },
  BOOKING: {
    EDIT: null,
    ACCEPT: null,
    REJECT: null
  },
  BOOKING_HISTORY: {
    EDIT: null,
    REJECT: null
  }
};
export default createActions(actionMap, ...actionTypes, {
  prefix
});